import React from 'react';
import { Divider } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
    root: {
        marginLeft: '6%',
    },
});

function ProductHeadingDivider({ classes }) {
    return <Divider className={classes.root} />;
}

ProductHeadingDivider.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductHeadingDivider);
